/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Standings_ScoreInputs */



/**
* | output |
* | --- |
* | "GW/VP/TP" |
*
* @param {League_Standings_ScoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_standings_score = /** @type {((inputs?: League_Standings_ScoreInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Standings_ScoreInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("GW/VP/TP")
	if (locale === "es") return /** @type {LocalizedString} */ ("GW/VP/TP")
	if (locale === "pt") return /** @type {LocalizedString} */ ("GW/VP/TP")
	if (locale === "it") return /** @type {LocalizedString} */ ("GW/VP/TP")
	return /** @type {LocalizedString} */ ("GW/VP/TP")
});